import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-tax-declaration-compare-detail',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './tax-declaration-compare-detail.component.html',
  styleUrl: './tax-declaration-compare-detail.component.scss'
})

export class TaxDeclarationCompareDetailComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;
  @Input() SequenceNo!: number;
  @Input() IsNewRegime!: boolean;
  @Input() Type!: string;

  user = [] as any;
  RegimeDetails = [] as any;
  constructor(
    private modalService: NgbModal,
    private session: SessionService,
    private incometax: IncometaxService,
    private common: CommonService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    if (this.ID > 0) {
      this.ESS_IncomeTaxCompare();
    }
  }

  ESS_IncomeTaxCompare() {
    this.isDisabled = true;
    try {
      if (this.common.ToLowerCase(this.user.EmpType) == 'back') {
        this.incometax.ESS_IncomeTaxCompareBACK({ OperationType: this.common.ToLowerCase(this.Type) == 'd' ? 'Declaration' : 'Investment', SelectType: 'D', SequenceNo: this.SequenceNo, NewRegime: this.IsNewRegime, EmpmasterID: this.user.UserId, TaxMainID: this.ID, StartYear: '', EndYear: '' }).subscribe({
          next: (response) => {
            if (response.Table) {
              this.RegimeDetails = response.Table;
            } else {
              this.RegimeDetails = []
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
      else if (this.common.ToLowerCase(this.user.EmpType) == 'front') {
        this.incometax.ESS_IncomeTaxCompare_FRONT({ OperationType: this.common.ToLowerCase(this.Type) == 'd' ? 'Declaration' : 'Investment', SelectType: 'D', SequenceNo: this.SequenceNo, NewRegime: this.IsNewRegime, EmpmasterID: this.user.UserId, TaxMainID: this.ID, StartYear: '', EndYear: '' }).subscribe({
          next: (response) => {
            if (response.Table) {
              this.RegimeDetails = response.Table;
            } else {
              this.RegimeDetails = []
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }

    } catch (e) {
      this.isDisabled = false;
    }
  }

  close() {
    this.activeModal.close();
  }
}
